import { WorkforceType } from '@revelio/data-access';

const WORKFORCE_SEGMENTS = [
  'full',
  'excludeContingent',
  'contingentOnly',
] as const;

export type WorkforceSegment = (typeof WORKFORCE_SEGMENTS)[number];

const DEFAULT_WORKFORCE_SEGMENT: WorkforceSegment = 'excludeContingent';

export const CONTINGENT_ONLY_SELECTION_ID = 'contingent_only';

const SELECTION_BY_SEGMENT: Record<
  WorkforceSegment,
  { id: string; name: string }
> = {
  full: { id: 'true', name: 'Included' },
  excludeContingent: { id: '', name: 'Excluded' },
  contingentOnly: { id: CONTINGENT_ONLY_SELECTION_ID, name: 'Contingent Only' },
};

const WORKFORCE_TYPE_BY_SEGMENT: Record<WorkforceSegment, WorkforceType> = {
  full: WorkforceType.Complete,
  excludeContingent: WorkforceType.FullTime,
  contingentOnly: WorkforceType.Contingent,
};

const isWorkforceSegment = (value: unknown): value is WorkforceSegment =>
  WORKFORCE_SEGMENTS.includes(value as WorkforceSegment);

export const resolveWorkforceSegment = (value: unknown): WorkforceSegment => {
  if (value === true) return 'full';
  if (value === false) return 'excludeContingent';
  if (isWorkforceSegment(value)) return value;
  return DEFAULT_WORKFORCE_SEGMENT;
};

export const workforceSegmentToLegacyBoolean = (
  segment: WorkforceSegment
): boolean => segment === 'full';

export const workforceSegmentToSelection = (
  segment: WorkforceSegment
): { id: string; name: string } => SELECTION_BY_SEGMENT[segment];

export const selectionIdToWorkforceSegment = (
  selectionId: string | undefined
): WorkforceSegment => {
  if (selectionId === 'true') return 'full';
  if (selectionId === CONTINGENT_ONLY_SELECTION_ID) return 'contingentOnly';
  return 'excludeContingent';
};

export const workforceSegmentToWorkforceType = (
  segment: WorkforceSegment
): WorkforceType => WORKFORCE_TYPE_BY_SEGMENT[segment];
